export const CONTAC_DASHBOARD_REGIONAL = () => `/contac-dashboard-regional`;
